/**
 * ShortcutButtonBlock
 */

import Icon from 'components/Icon';
import BlockContainer from 'layouts/BlockLayout';
import React from 'react';
import { colors } from 'theme/colors';
import { LinkType } from 'types/global';
import { P } from 'components/Text/Text.styles';
import {
	Container,
	Link,
	LinksContainer,
	StyledP,
	StyledH2,
} from './ShortcutButtonBlock.styles';

interface Props {
	/** Block title */
	heading?: string;

	/** Block description */
	preamble?: string;

	/** background color */
	backgroundColor?: string;

	/** linst of buttons */
	links?: LinkType[];
}

/** Main description for this component. */
const ShortcutButtonBlock: React.FC<Props> = ({
	heading = '',
	preamble = '',
	backgroundColor = 'white',
	links = [],
}) => {
	const getBackgroundColor = (color: string) => {
		switch (color) {
			case 'white':
				return { backgroundColor: colors.white, color: colors.greyDark };
			case 'greyLighter':
				return { backgroundColor: colors.greyLighter, color: colors.greyDark };
			case 'yellow':
				return {
					backgroundColor: colors.yellow,
					color: colors.greyDark,
				};
			case 'blue':
				return { backgroundColor: colors.blue, color: colors.white };
			case 'darkblue':
				return { backgroundColor: colors.blueDark, color: colors.white };
			default:
				return { backgroundColor: colors.white, color: colors.greyDark };
		}
	};

	return (
		<BlockContainer>
			<Container>
				<StyledH2>{heading}</StyledH2>
				{preamble && <P>{preamble}</P>}
				<LinksContainer>
					{links &&
						links.length > 0 &&
						links.map((link, index) => (
							<Link
								key={index}
								href={link.link}
								target={link.target ? link.target : '_self'}
								rel={link.target === '_blank' ? 'noopener noreferrer' : ''}
								{...getBackgroundColor(backgroundColor)}
							>
								<StyledP>{link.text}</StyledP>
								<Icon
									icon="arrowRight"
									size={0}
									className="shortcut-button-icon"
									color="currentColor"
								/>
							</Link>
						))}
				</LinksContainer>
			</Container>
		</BlockContainer>
	);
};

export default ShortcutButtonBlock;
